(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-subscription"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.subscription-premium .subscription-form-premium');
    if (!form) return;

    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('.subscription-premium-submit');
    const messageEl = document.getElementById('PremiumMessage-{{ section.id }}');

    form.addEventListener('submit', function(e) {
      const email = input.value.trim();

      input.classList.remove('error', 'success');
      if (messageEl) {
        messageEl.classList.remove('show', 'success', 'error');
        messageEl.textContent = '';
      }

      const emailPattern = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(email)) {
        e.preventDefault();
        input.classList.add('error');
        if (messageEl) {
          messageEl.textContent = 'Please enter a valid email address.';
          messageEl.classList.add('show', 'error');
        }
        return;
      }

      button.classList.add('loading');
      button.disabled = true;
    });

    const errorMessage = form.closest('.subscription-premium-card').querySelector('.subscription-message.error.show');
    if (errorMessage) {
      input.classList.add('error');
      button.classList.remove('loading');
      button.disabled = false;
    }

    const successMessage = form.closest('.subscription-premium-card').querySelector('.subscription-message.success.show');
    if (successMessage) {
      input.classList.add('success');
      input.value = '';
      button.classList.remove('loading');
      button.disabled = false;
    }

    if (!form.querySelector('.subscription-message.error.show') && !form.querySelector('.subscription-message.success.show')) {
      button.classList.remove('loading');
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
